import type { HelpdeskService } from './types';

export interface TemplateVariable {
  name: string;
  description: string;
  /** What it looks like in the preview. */
  sample: string;
}

export interface EmailTemplate {
  key: string;
  service: HelpdeskService;
  label: string;
  description: string;
  group: string;
  subject: string;
  body: string;
  /** The school has changed this one; otherwise it's Edvora's wording. */
  customized: boolean;
  updatedAt: string | null;
  updatedByName: string | null;
  defaults: { subject: string; body: string };
  variables: TemplateVariable[];
  /** Variables the subject has to keep, so replies still find their ticket. */
  requiredInSubject: string[];
  preview: RenderedEmail;
}

export interface RenderedEmail {
  subject: string;
  text: string;
}

export interface EmailTemplateList {
  items: EmailTemplate[];
  mailboxes: {
    IT: { ready: boolean; address: string | null };
    FACILITIES: { ready: boolean; address: string | null } | null;
  };
}

export const templatePath = (template: Pick<EmailTemplate, 'key' | 'service'>, action = '') =>
  `/email-templates/${template.key}${action}?service=${template.service}`;

export const SERVICE_LABEL: Record<HelpdeskService, string> = { IT: 'Technology', FACILITIES: 'Facilities' };
